import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

/**
 * When the user leaves the tab: every 5s the title alternates UIDO “misses you” 🧡
 * and the 🐙 line (see tabTitle.* in locales).
 */
const DocumentTitleTabCycle = () => {
  const { t } = useTranslation();
  const intervalRef = useRef(null);
  const originalTitleRef = useRef("");
  const tickRef = useRef(0);

  useEffect(() => {
    const clearCycle = () => {
      if (intervalRef.current != null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      tickRef.current = 0;
    };

    const restoreTitle = () => {
      if (originalTitleRef.current) {
        document.title = originalTitleRef.current;
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        clearCycle();
        restoreTitle();
        return;
      }

      clearCycle();
      originalTitleRef.current = document.title || "";
      tickRef.current = 0;

      intervalRef.current = window.setInterval(() => {
        if (document.visibilityState === "visible") {
          clearCycle();
          restoreTitle();
          return;
        }

        tickRef.current += 1;
        const tick = tickRef.current;
        const isUido = tick % 2 === 1;
        document.title = isUido
          ? t("tabTitle.altUidoStar")
          : t("tabTitle.altOctopus");
      }, 5000);
    };

    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      clearCycle();
    };
  }, [t]);

  return null;
};

export default DocumentTitleTabCycle;
